module.exports = __webpack_public_path__ + "8e53bfbfe2b96020b54a2a7400c6eda0.png";